export default __webpack_public_path__ + "static/media/1366.45864755.png";